// libs
import React from "react";

function Generic() {
    return <div id="generic-layout" />;
}

export default Generic;
